<label class="FieldLabel" [for]="uniqueInputId" *ngIf="hasLabel">{{ label }}</label>
<div class="p-inputgroup">
  <span *ngIf="inputGroupLabel && inputGroupLabel != ''" class="p-inputgroup-addon test-city-input">{{ inputGroupLabel }}</span>

  <input
    pInputText
    class="test-zipcode"
    [class.ng-invalid]="control?.invalid"
    type="text"
    [ngModel]="textValue"
    [attr.aria-label]="'shared.Zipcode' | translate"
    [attr.aria-invalid]="control?.invalid && control.touched && control.dirty"
    [maxLength]="inputMaxLength"
    [id]="uniqueInputId"
    [disabled]="disabled"
    [placeholder]="'shared.EnterZip' | translate"
    (keyup)="onChanged($event)"
  />
</div>

<!-- Validation error messages  -->
<div *ngIf="control?.errors && control.touched && control.dirty" aria-atomic="true" role="region" aria-live="polite">
  <p class="field-error" *ngIf="control.errors.required" translate>errorMessages.MustBeFilled</p>
  <p class="field-error" *ngIf="control.errors.length" translate [translateParams]="{ length: inputMaxLength }">errorMessages.MustBeXDigits</p>
  <p class="field-error" *ngIf="control.errors.maxLength" translate [translateParams]="{ length: inputMaxLength }">errorMessages.MaxXDigits</p>
  <p class="field-error" *ngIf="control.errors.digitsOnly" translate>errorMessages.OnlyDigits</p>
</div>
